import React from 'react';
import { Header } from './components/Header';
import { PainPoints } from './components/PainPoints';
import { Authority } from './components/Authority';
import { Solution } from './components/Solution';
import { Testimonials } from './components/Testimonials';
import { Offer } from './components/Offer';
import { CallToAction } from './components/CallToAction';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-full bg-gray-50 font-sans" data-id="element-0">
      <Header data-id="element-1" />
      <PainPoints data-id="element-2" />
      <Authority data-id="element-3" />
      <Solution data-id="element-4" />
      <Testimonials data-id="element-5" />
      <Offer data-id="element-6" />
      <CallToAction data-id="element-7" />
      <Footer data-id="element-8" />
    </div>;
}